import { apiFetch } from '@/util/apiClient';
import { getErrorMessage } from '@/util/errorUtils';
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PasswordResetRequest() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [code, setCode] = useState<string | null>(null);

  const { mutate } = useMutation({
    mutationFn: async () => {
      const result = await apiFetch('/auth/password-reset/', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });
      setCode((result as any).code);
    },
    onError: (err: unknown) => {
      setError(getErrorMessage(err));
    },
  });

  if (code) {
    navigate(`/reset/${code}`);
  }

  return (
    <Container maxWidth={'xs'}>
      <Paper
        elevation={6}
        sx={{ p: 4, mt: 8, display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <Typography variant={'h4'} gutterBottom>
          Reset Password
        </Typography>
        {error && <Alert severity={'error'}>{error}</Alert>}
        <Box
          component={'form'}
          onSubmit={(e) => {
            e.preventDefault();
            mutate();
          }}
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <TextField
            label={'Email'}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Button type={'submit'} variant={'contained'}>
            Send Code
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
